import {
  Tooltip,
  Button,
  Switch,
  FormGroup,
  FormControlLabel,
  Grid,
  TableRow,
  TableCell,
  Collapse,
  MenuItem,
} from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import _ from "lodash";
// Component
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import EditForm from "./editCustomer";
import TableFormat from "../../../partials/TableFormat";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import FilterList from "../../../partials/filterList";
import {
  genders,
  chartAgeCustomer,
  filterNotArrived,
} from "../../../utils/setting";
import {
  CountryDropdown,
  DistrictDropdown,
  CityDropdown,
} from "../../../partials/selectAddress";
// Style
import { styles } from "./styles";
import InputFormat from "../../../partials/inputForm";
import { Link } from "react-router-dom";
const headCells = [
  {
    key: "info",
    numeric: false,
    disablePadding: false,
    label: "customer_listcustomer_infomation",
  },
  {
    key: "contact",
    numeric: false,
    disablePadding: false,
    label: "customer_listcustomer_contact",
  },
  {
    key: "address",
    numeric: false,
    disablePadding: false,
    label: "customer_listcustomer_address",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];
const listCountries = [
  {
    label: "VN",
    value: "VN",
  },
  {
    label: "US",
    value: "US",
  },
]
const filterAge = Object.values(chartAgeCustomer).map((e) => {
  return { name: e.name, key: e.key, label: e.label };
});

class ListCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      data: [],
      collapse: [],
      districtCustomer: "",
      customerAge: null,
      customerGender: null,
      total: 0,
      fromSpentRealMoney: null,
      toSpentRealMoney: null,
      fromVoucherMoney: null,
      toVoucherMoney: null,
      filterRealMoney: false,
      filterVoucherMoney: false,
      openDrawer: false,
      listFilter: {
        gender: "",
        age: "",
        notArrived_in: "",
        country: "",
        city: "",
        district: "",
        spentRealMoney: "",
        voucherMoney: ""
      },
    };
    this.afterFetch = this.afterFetch.bind(this);
    this.deleteCustomer = this.deleteCustomer.bind(this);
  }
  componentDidMount = () => {
    this.props.onRef(this);
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        fromSpentRealMoney: null,
        toSpentRealMoney: null,
        fromVoucherMoney: null,
        toVoucherMoney: null,
        filterRealMoney: false,
        filterVoucherMoney: false,
        customerAge: null,
        customerGender: null,
        lastTime: null,
        city: null,
        district: null,
        country: null,
        ward: null,
        listFilter: {
          gender: "",
          age: "",
          notArrived_in: "",
          country: "",
          city: "",
          district: "",
          spentRealMoney: "",
          voucherMoney: ""
        },
      },
      function () {
        _this.getListCustomer();
      }
    );
  };
  checkListFilter = () => {
    let {
      city,
      district,
      country,
      customerAge,
      customerGender,
      lastTime,
      listFilter,
      filterRealMoney,
      fromSpentRealMoney,
      toSpentRealMoney,
      filterVoucherMoney,
      fromVoucherMoney,
      toVoucherMoney,
    } = this.state;
    listFilter["gender"] = genders.find(item => item.value === customerGender);
    listFilter["gender"] = listFilter["gender"] ? listFilter["gender"].label : "";

    listFilter["age"] = filterAge.find(item => String(item.key) === String(customerAge));
    listFilter["age"] = listFilter["age"] ? listFilter["age"].label : "";

    listFilter["notArrived_in"] = filterNotArrived.find(item => String(item.value) === String(lastTime));
    listFilter["notArrived_in"] = listFilter["notArrived_in"] ? listFilter["notArrived_in"].label : "";

    listFilter["country"] = listCountries.find(item => item.value === country);
    listFilter["country"] = listFilter["country"] ? listFilter["country"].label : "";

    listFilter["city"] = city;

    listFilter["district"] = district;

    if (filterRealMoney && (fromSpentRealMoney || toSpentRealMoney)) {
      listFilter['spentRealMoney'] = `${Number(fromSpentRealMoney)} - ${Number(toSpentRealMoney)}`;
    }
    if (filterVoucherMoney && (fromVoucherMoney || toVoucherMoney)) {
      listFilter['voucherMoney'] = `${Number(fromVoucherMoney)} - ${Number(toVoucherMoney)}`;
    }
    this.setState({ listFilter })
  }
  getListCustomer = async (payload = {}, applyFilter = true) => {
    this.handleOpenCollapes(-1);
    this.loading.startLoading();
    let query = this.state;
    query = { ...query, ...payload };
    let {
      city,
      district,
      ward,
      country,
      customerAge,
      customerGender,
      lastTime,
      filterRealMoney,
      filterVoucherMoney,
      fromSpentRealMoney,
      toSpentRealMoney,
      fromVoucherMoney,
      toVoucherMoney,
    } = query;
    let { rowsPerPage, page } = this.mTable.state;
    let check;
    let filterRange = {};
    if (filterRealMoney && (fromSpentRealMoney || toSpentRealMoney)) {
      filterRange.spentRealMoney = [
        Number(fromSpentRealMoney),
        Number(toSpentRealMoney),
      ];
    }
    if (filterVoucherMoney && (fromVoucherMoney || toVoucherMoney)) {
      filterRange.voucherMoney = [
        Number(fromVoucherMoney),
        Number(toVoucherMoney),
      ];
    }
    if (customerAge) {
      filterRange.customerAge = customerAge;
    }
    if (lastTime) {
      filterRange.lastTime = lastTime;
    }

    let filter = {};
    if (customerGender) {
      filter.customerGender = customerGender;
    }
    if (city) {
      filter.customerCity = city;
    }
    if (district) {
      filter.customerDistrict = district;
    }
    if (ward) {
      filter.customerWard = ward;
    }
    if (country) {
      filter.customerCountry = country;
    }

    if (applyFilter) {
      check = await this.props.customerDispatch.getListCustomer({
        limit: !payload.export ? rowsPerPage : undefined,
        page: !payload.export ? page : undefined,
        filter: filter,
        filterRange: filterRange,
        ...payload,
      });
    } else {
      check = await this.props.customerDispatch.getListCustomer({
        limit: !payload.export ? rowsPerPage : undefined,
        page: !payload.export ? page : undefined,
        ...payload,
      });
    }

    if (check && check.code === 0) {
      this.mSnackbar.handleClick(check.message, "error");
    }
    this.setState({ openDrawer: false });
    this.loading.stopLoading();
    this.checkListFilter()
    return check;
  };
  changeFormat = (datetime) => {
    return datetime ? moment(datetime).format("DD/MM/YYYY") : "";
  };
  handleExport = async () => {
    const header = [
      "Tên KH",
      "Mã vùng",
      "SĐT KH",
      "Email KH",
      "Quốc gia",
      "Tiểu bang",
      "Thành phố",
      "Quận",
      "Phường/Huyện",
      "Địa chỉ",
      "Latitude",
      "Longitude",
      "Giới tính",
      "Tuổi",
      "CMND",
      "Số dư",
      "Chi tiêu thực tế",
      "Chi tiêu ảo",
      "Số dư voucher",
      "Giá trị voucher",
      "Quan tâm - Menu item",
      "Quan tâm - Voucher",
      "Dịch vụ đã sử dụng",
      "Lần cuối đến spa",
    ];
    await this.getListCustomer({ export: true });
    const { listCustomer = [] } = this.props;

    let title = "DANH SACH KHACH HANG";
    const exportData = [[title], header];
    let data = listCustomer.map((e) => {
      return [
        e.customerName,
        e.countryCode,
        e.customerMobile,
        e.customerEmail,
        e.customerCountry,
        e.customerState,
        e.customerCity,
        e.customerDistrict,
        e.customerWard,
        e.customerAddress,
        e.customerLatitude,
        e.customerLongitutde,
        e.customerGender,
        e.customerAge,
        e.customerIdentifyCard,
        e.balance,
        e.spentRealMoney,
        e.spentVirtualMoney,
        e.voucherBalance,
        e.voucherMoney,
        e.interesting && e.interesting.length
          ? e.interesting
            .filter((e) => e.type === "menuItem")
            .map((e) => e.id)
            .join(", ")
          : "",
        e.interesting && e.interesting.length
          ? e.interesting
            .filter((e) => e.type === "voucher")
            .map((e) => e.id)
            .join(", ")
          : "",
        e.useServices && e.useServices.length
          ? e.useServices
            .map(
              (e) =>
                `Menu: ${e.menuId}, Menu item: ${e.menuItemId}, Total money: ${e.totalMoney}, Quantity: ${e.quantity}`
            )
            .join(", \n")
          : "",
        e.lastTime ? moment(e.lastTime).format("DD/MM/YYYY HH.mm A") : "",
      ];
    });
    this.props.exportExcel({
      exportData: exportData.concat(data),
      name: `REPORT MASSPA ${title}`,
      sheet: `Report`,
      length: header.length - 1,
    });
  };
  handleChange = (e) => {
    let target = e.target;
    this.setState(
      { [target.name]: target.checked || target.value },
      function () {
        // this.getListCustomer()
      }
    );
  };
  handleOpenCollapes = (id) => {
    const listCustomer = this.props.listCustomer;
    const collapse = this.state.collapse;
    for (let i = 0; i <= listCustomer.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  async afterFetch(check) {
    let { t } = this.props;
    if (check.code) {
      this.handleOpenCollapes(-1);
      this.mSnackbar.handleClick(t("customer_listcustomer_edit_successfully"));
      this.updateChart();
    } else if (!check.code) {
      this.mSnackbar.handleClick(
        t("customer_listcustomer_edit_unsuccessfully") + " " + check.message,
        "error"
      );
    }
    this.getListCustomer();
  }
  async deleteCustomer(selected = []) {
    let { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.customerDispatch.deleteCustomer(selected);
      if (check.code === 1) {
        this.mSnackbar.handleClick(
          t("customer_listcustomer_delete_customer_successfully")
        );
        this.updateChart();
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("customer_listcustomer_delete_customer_unsuccessfully"),
          "error"
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"), "warning");
      return false;
    }
  }
  updateChart = () => {
    this.props.customerDispatch.getChart();
  };
  renderInfo = (customer) => {
    const { classes, t } = this.props;
    return (
      <div className={classes.containerCard}>
        <div className={classes.containerImageRound}>
          <img
            className={classes.containerImageRound}
            src={customer.customerImage || "/images/noneImage.svg"}
          />
          {customer.haveAccount ? (
            <div className={classes.containerIconMasspa}>
              <Tooltip title={t("user_voucher_user_is_registered_account")}>
                <img
                  className={classes.iconMasspa}
                  src="../../../rectangle-logo.png"
                />
              </Tooltip>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={classes.rightCard}>
          <div className={classes.nameTitle}>
            {customer.customerName}
            {customer.customerGender === "male" ? (
              <img className={classes.iconGender} src={"/images/male.svg"} />
            ) : customer.customerGender === "female" ? (
              <img className={classes.iconGender} src={"/images/female.svg"} />
            ) : (
              ""
            )}
          </div>
          <div>
            <span className={classes.keyName}>
              {t("customer_listcustomer_day_of_birth")}:{" "}
            </span>{" "}
            {this.changeFormat(customer.customerBirthDay)}
          </div>
        </div>
      </div>
    );
  };
  renderCollapse = (row, index) => {
    const { classes, t, listCustomer, total } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditForm
              afterFetch={this.afterFetch}
              customerData={listCustomer[index]}
              OpenCustomerDetail={this.props.OpenCustomerDetail}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  actionColumn = (customer, index) => {
    const { classes, t, listCustomer, total } = this.props;
    let customerData = listCustomer.find((e) => e._id === customer.id);
    return (
      <div className={classes.containerIcons}>
        <Link to={"/customer/" + customerData._id}>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            className={classes.buttonOnRow}
          >
            {t("customer_listcustomer_report")}
          </Button>
        </Link>
      </div>
    );
  };
  render() {
    const { classes, t, listCustomer, total, count } = this.props;
    const {
      collapse,
      filterRealMoney,
      filterVoucherMoney,
      fromSpentRealMoney,
      toSpentRealMoney,
      fromVoucherMoney,
      toVoucherMoney,
      customerAge,
      customerGender,
      lastTime,
      city,
      district,
      country,
      listFilter,
    } = this.state;
    return (
      <React.Fragment>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getListCustomer}
        >
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("gender")}
              placeholder={t("pls_select")}
              fullWidth
              value={customerGender}
              onChange={this.handleChange}
              name="customerGender"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              // helperText="Please select your currency"
              margin="normal"
              variant="outlined"
            >
              {genders.map((gender, index) => {
                return (
                  <MenuItem key={index} value={gender.value}>
                    {t(gender.label)}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("age")}
              placeholder={t("pls_select")}
              fullWidth
              value={customerAge}
              onChange={this.handleChange}
              name="customerAge"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
              variant="outlined"
            >
              {filterAge.map((e, index) => {
                return (
                  <MenuItem key={index} value={e.key}>
                    {e.name} {e.key !== "other" && t("age")}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("notArrived_in")}
              placeholder={t("pls_select")}
              fullWidth
              value={lastTime}
              onChange={this.handleChange}
              name="lastTime"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              // helperText="Please select your currency"
              margin="normal"
              variant="outlined"
            >
              {filterNotArrived.map((e, index) => {
                return (
                  <MenuItem key={index} value={e.value}>
                    {e.value !== "other"
                      ? `${e.label} ${t("month")}`
                      : t("other")}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>

          <Grid item xs={12} sm={12}>
            <CountryDropdown
              label={t("country")}
              name="country"
              priorityOptions={["VN"]}
              variant="outlined"
              whitelist={["VN", "US"]}
              valueType="short"
              blankOptionLabel={t("country")}
              onChange={this.handleChange}
              defaultOptionLabel={t("pls_select")}
              value={country}
              disableUnderline={true}
              showDefaultOption={true}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <CityDropdown
              label={t("city")}
              country={country}
              variant="outlined"
              value={city}
              disabled={country !== "VN"}
              blankOptionLabel={t("city")}
              name="city"
              onChange={this.handleChange}
              countryValueType="short"
              defaultOptionLabel={t("pls_select")}
              disableUnderline={true}
              showDefaultOption={true}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <DistrictDropdown
              label={t("district")}
              defaultOptionLabel={t("pls_select")}
              country={country}
              variant="outlined"
              region={city}
              value={district}
              disabled={country !== "VN"}
              blankOptionLabel={t("district")}
              name="district"
              onChange={this.handleChange}
              countryValueType="short"
              disableUnderline={true}
              showDefaultOption={true}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={filterRealMoney}
                    onChange={this.handleChange}
                    name="filterRealMoney"
                  />
                }
                label={t("customer_spentRealMoney")}
              />
            </FormGroup>
          </Grid>
          {filterRealMoney && (
            <>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("from")}
                  name="fromSpentRealMoney"
                  margin="normal"
                  type="number"
                  fullWidth
                  value={fromSpentRealMoney}
                  onChange={this.handleChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("to")}
                  name="toSpentRealMoney"
                  margin="normal"
                  type="number"
                  fullWidth
                  value={toSpentRealMoney}
                  onChange={this.handleChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </>
          )}

          <Grid item xs={12} sm={12}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={filterVoucherMoney}
                    onChange={this.handleChange}
                    name="filterVoucherMoney"
                  />
                }
                label={t("customer_voucherMoney")}
              />
            </FormGroup>
          </Grid>
          {filterVoucherMoney && (
            <>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("from")}
                  name="fromVoucherMoney"
                  margin="normal"
                  type="number"
                  fullWidth
                  value={fromVoucherMoney}
                  onChange={this.handleChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("to")}
                  name="toVoucherMoney"
                  margin="normal"
                  type="number"
                  fullWidth
                  value={toVoucherMoney}
                  onChange={this.handleChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </>
          )}
        </FilterList>
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          contentDialog={t(
            "customer_listcustomer_do_you_want_to_remove_customer_from_customer_list"
          )}
          onDelete={this.deleteCustomer}
          title={t("customer_listcustomer_all_customers")}
          showFilter={true}
          openFilter={(e) => this.showFilter(e)}
          listFilter={listFilter}
          showActionToolbar={true}
          titleActionToolbar={t("customer_listcustomer_export_excel")}
          actionToolbar={this.handleExport}
          placeholder={t("customer_search_by_name_email_phone")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getListCustomer}
          actionColumn={this.actionColumn}
          rows={listCustomer.map((row, index) => {
            let validPhone = _parsePhoneNumber(
              row.countryCode,
              row.customerMobile
            ).format_internal;
            return {
              id: row._id,
              info: this.renderInfo(row),
              contact: (
                <React.Fragment>
                  <div> {validPhone}</div>
                  <div> {row.customerEmail}</div>
                </React.Fragment>
              ),
              address: (
                <React.Fragment>
                  <div>
                    {row.customerWard && row.customerWard + ","}{" "}
                    {row.customerDistrict}
                  </div>
                  <div>
                    {row.customerCity && row.customerCity + ","}{" "}
                    {row.customerCountry}
                  </div>{" "}
                </React.Fragment>
              ),
              // report: this.renderButtonReport(row, index)
            };
          })}
        />
      </React.Fragment>
    );
  }
}
ListCustomer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listCustomer: state.customer.listCustomer,
  total: state.customer.total,
  count: state.customer.count,
});

const mapDispatch = (dispatch) => ({
  exportExcel: dispatch.exportExcel.exportExcel,
  customerDispatch: dispatch.customer,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListCustomer)
  )
);
